import { initializeAbandonCartEvent } from './abandon_cart';

const { abandonCartPopup } = ecom.craftConfig.features?.salesforce || {};

if (abandonCartPopup) {
  initializeAbandonCartEvent();
}
